module.exports = __webpack_public_path__ + "kg.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/kg.svg
// module id = 888
// module chunks = 0